import React from 'react';
import { Link2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';

// A link to a page of the portal that anyone with access can open: no token
// in it, so whoever opens it signs in as themselves (see RecruitmentPortalApp).
export const portalLink = (params) => (
  `${window.location.origin}/apps/recruitment-portal?${new URLSearchParams(params).toString()}`
);

const CopyLinkButton = ({ params, what }) => {
  const copy = async () => {
    const url = portalLink(params);
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link copied', { description: `Anyone with access to the portal can open this ${what}.` });
    } catch (_) {
      // Clipboard blocked (permissions, or not a secure context): copy by hand.
      window.prompt('Copy this link', url);
    }
  };

  return (
    <Button variant="outline" onClick={copy} title={`Copy a link to this ${what}`} data-testid="copy-link">
      <Link2 className="w-4 h-4 sm:mr-2" />
      <span className="hidden sm:inline">Copy link</span>
    </Button>
  );
};

export default CopyLinkButton;
